import { gql } from 'graphql-tag'
import {
  fragmentModuleInternalVideo,
  fragmentModuleMedia,
  fragmentModuleNavigationLink,
  fragmentModuleVideo
} from '../fragments'

export default gql`
  ${fragmentModuleNavigationLink}
  ${fragmentModuleMedia}
  ${fragmentModuleVideo}
  ${fragmentModuleInternalVideo}
  fragment ModuleExpandableCardFragment on ModuleExpandableCard {
    sys {
      id
    }
    icon
    eyebrow
    title
    description
    media {
      ... on ModuleMedia {
        contentType: __typename
        ...ModuleMediaFragment
      }
      ... on ModuleVideo {
        contentType: __typename
        ...ModuleVideoFragment
      }
      ... on ModuleInternalVideo {
        contentType: __typename
        ...ModuleInternalVideoFragment
      }
    }
    link {
      ...ModuleNavigationLinkFragment
    }
    benefit1Icon
    benefit1Title
    benefit1Text
    benefit2Icon
    benefit2Title
    benefit2Text
    benefit3Icon
    benefit3Title
    benefit3Text
    benefit4Icon
    benefit4Title
    benefit4Text
    benefit5Icon
    benefit5Title
    benefit5Text
  }
`
